import { __assign, __rest } from "tslib";
import React from 'react';
import VeltSubtitlesTextWireframe from '../VeltSubtitlesTextWireframe/VeltSubtitlesTextWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltSubtitlesEmbedModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-embed-mode-wireframe", __assign({}, transformedProps), children));
};
VeltSubtitlesEmbedModeWireframe.Text = VeltSubtitlesTextWireframe;
export default VeltSubtitlesEmbedModeWireframe;
